import { StyledComponentProps } from "@mui/styles";
import { GlobalSearchClassKey } from "assets/jss/common-styles";
import { HeaderStylesClassKey } from "assets/jss/layouts/headerLinksStyle";
import * as React from "react";
import GlobalSearchPreview from "views/Search/Components/GlobalSearchPreview";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    open: boolean;
}

interface IProps {
}

type Props = IProps & StyledComponentProps<HeaderStylesClassKey> & StyledComponentProps<GlobalSearchClassKey>;

/////////////////////////////////////////////////////////////////////////////////////////////////

class HeaderSearch extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            open: false
        };
    }

    public render() {
        const { classes } = this.props;
        return (<GlobalSearchPreview classes={classes} />);
    }
}


export default HeaderSearch;
